<template>
  <div class="feed-item single-img"  data-spm-type="resource">
    <a :href="feedData.url" target="_blank" class="feed-item__box" :data-mphref="feedData.personalPage">
        <h5 class="feed-item__title">{{feedData.title}}</h5>
        <div class="img-box img-do feed-item__left">
            <img class="feed-item__cover" :data-src="feedData.images[0]" src="//statics.itc.cn/web/static/images/pic/preload.png" alt="配图">
        </div>
        <div class="feed-item__right">
            <p class="feed-item__des">{{feedData.brief}}</p>
            <div class="feed-item__footer">
                <a class="auther-box" :href="feedData.personalPage">
                    <img class="auther-img" :src="feedData.authorPic" alt="作者头像">
                    <span class="auther__name"><span></span>{{feedData.authorName}}</span>
                </a>
                <span class="time">{{feedData.fixTime}}</span>
            </div>
        </div>
    </a>
</div>
</template>

<script>
export default {
  props: {
    feedData: {
      type: Object,
      required: true,
      default: () => ({
        url: '',
        personalPage: '',
        title: '',
        brief: '',
        authorPic: '',
        authorName: '',
        fixTime: ''
      })
    }
  }
};
</script>

<style scoped>
</style>
